import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';

import LargeCard from '@/components/LargeCard';
import { ticketAtom, useUpdateRecommendation } from '@/pages/Ticket';
import { userIsInternalAtom } from '@/store/user.store';

import useStyles from './TicketDetailsRecommendations.styles';

const TicketDetailsRecommendations = () => {
  const [{ ticket_recommendations }] = useAtom(ticketAtom);
  const [userIsInternal] = useAtom(userIsInternalAtom);
  const { control, setValue } = useForm();
  const { classes } = useStyles();
  const updateRecommendation = useUpdateRecommendation();

  useEffect(() => {
    ticket_recommendations?.forEach((item, index) => {
      setValue(`recommendations[${index}].completed`, item.completed);
    });
  }, [ticket_recommendations]);

  return (
    <LargeCard title="Recommendations">
      <form>
        {/* TODO: api return this list in asc order by id */}
        {ticket_recommendations?.map((item, index) => (
          <Stack key={uuidv4()}>
            <Controller
              control={control}
              name={`recommendations[${index}].completed`}
              defaultValue={ticket_recommendations[index]?.completed}
              render={({ field }) => (
                <FormControlLabel
                  className={classes.ticketDetailsRecommendationsCheckboxLabel}
                  control={
                    <Checkbox
                      checked={field.value}
                      disabled={userIsInternal}
                      disableRipple
                      onChange={() => {
                        // update react-form-hook value
                        field.onChange(!field.value);
                        const recommendationUpdate = {
                          id: item.id,
                          body: item.body,
                          completed: !field.value
                        };
                        // update database value
                        updateRecommendation.mutate(recommendationUpdate);
                      }}
                      sx={{ pl: 0 }}
                    />
                  }
                  label={ticket_recommendations[index]?.body || ''}
                />
              )}
            />
          </Stack>
        ))}
        {ticket_recommendations?.length === 0 && (
          <>No recommendations provided.</>
        )}
      </form>
    </LargeCard>
  );
};

export default TicketDetailsRecommendations;
